import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import SEO from '../components/common/SEO';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { registerUser, clearError } from '../store/slices/authSlice';

export default function RegisterPage() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((s) => s.auth);
  const [form, setForm] = useState({ name: '', email: '', password: '', languagePreference: i18n.language });

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearError());
    const result = await dispatch(registerUser(form));
    if (registerUser.fulfilled.match(result)) {
      toast.success('Account created!');
      navigate('/dashboard');
    } else {
      toast.error(result.payload || 'Registration failed');
    }
  };

  return (
    <>
      <SEO title={t('auth.register')} />
      <section className="min-h-[70vh] flex items-center justify-center px-4 py-12">
        <div className="card w-full max-w-md">
          <h1 className="text-2xl font-display font-bold text-center mb-6">{t('auth.register')}</h1>
          {loading ? <LoadingSpinner /> : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <input className="input-field" placeholder={t('auth.name')} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              <input type="email" className="input-field" placeholder={t('auth.email')} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
              <input type="password" className="input-field" placeholder={t('auth.password')} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} minLength={6} required />
              <button type="submit" className="btn-primary w-full">{t('auth.register')}</button>
            </form>
          )}
          <p className="text-center mt-4 text-sm text-gray-500">
            {t('auth.hasAccount')} <Link to="/login" className="text-brand-600 font-semibold">{t('auth.login')}</Link>
          </p>
        </div>
      </section>
    </>
  );
}
